/**
 * После статуса ноги живой кадр иногда снимает URL — гиперссылка на исходе
 * пропадала. Держим последний рабочий адрес этой же ноги.
 */

const last = new Map<string, string>();

function seat(id: string, source: string, side: string): string {
  return `${id}\0${source}\0${side}`;
}

export function rememberHref(
  id: string,
  source: string,
  side: string,
  href: string | null,
): string | null {
  const key = seat(id, source, side);
  if (href) last.set(key, href);
  return last.get(key) ?? href;
}

export function forgetHrefs(): void {
  last.clear();
}
